import { CoreDomainSearchBackend } from '@wix/core-domain-search';
import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { useCallback } from 'react';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
import { withTld } from '../utils/tldQuery';
import { useIsGateRevamp3Enabled } from './useIsGateRevamp3Enabled';
export const TLDS_LIMIT = 6;
export const useFilterableTlds = function (enabled) {
  if (enabled === void 0) {
    enabled = true;
  }
  const _CoreDomainSearchBack = CoreDomainSearchBackend.hooks.useGetTldSelectorData({
      limit: TLDS_LIMIT
    }, enabled, {
      cacheTime: Infinity,
      staleTime: Infinity,
      useErrorBoundary: false,
      suspense: false,
      retry: false
    }),
    data = _CoreDomainSearchBack.data;
  return ((data == null ? void 0 : data.tldSelectorData) ?? []).map(_ref => {
    let tld = _ref.tld;
    return tld;
  });
};
export const useTldPress = function (componentName, scrollBack) {
  if (scrollBack === void 0) {
    scrollBack = false;
  }
  const selectedTlds = CoreDomainSearchStore.useTlds();
  const storeQuery = CoreDomainSearchStore.useQuery();
  const inputRef = CoreDomainSearchStore.useInputRef();
  const filterable = useFilterableTlds(useIsGateRevamp3Enabled());
  const filterableKey = filterable.join(',');
  return useCallback((tld, bi) => {
    var _inputRef$input;
    const query = ((inputRef == null || (_inputRef$input = inputRef.input) == null ? void 0 : _inputRef$input.value) ?? storeQuery).trim();
    const domain = withTld(query, tld, [...selectedTlds, ...filterable]);
    const filterSelected = filterable.includes(tld);
    DomainSearchGateModule.internals.bi.onGateTldClick == null || DomainSearchGateModule.internals.bi.onGateTldClick({
      ...bi,
      componentName,
      tld,
      domain,
      isSearchExecuted: false,
      filterSelected
    });
    const input = inputRef == null ? void 0 : inputRef.input;
    if (input) {
      input.value = domain;
    }
    CoreDomainSearchStore.setQuery(domain);
    CoreDomainSearchStore.setTlds(filterSelected ? [tld] : []);
    inputRef == null || inputRef.focus();
    const caret = domain.length - tld.length - 1;
    input == null || input.setSelectionRange(caret, caret);
    if (scrollBack) {
      input == null || input.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
    return domain;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on the lists' contents
  [inputRef, storeQuery, selectedTlds, filterableKey, scrollBack, componentName]);
};
//# sourceMappingURL=useTldPress.js.map